import { useModuleGate } from '../lib/moduleGate';

/**
 * True when the comparison-set validation step is on: the S3 criteria surface
 * gains the structural moment — Twins identity, then Nexus structure, then the
 * anti-pattern report — with a recorded validation event before criteria are
 * finalized. Canonical gate (§2.7): `comparison_set_validation` workspace
 * module + flag.
 *
 * The step is inserted into the existing session flow, never forked into a
 * second route (§2.6), so when this is off the S3 panel renders exactly as it
 * did and every detector keeps running in the surfaces it already had.
 */
export function useComparisonSetValidationEnabled(): boolean {
  return useModuleGate('comparison_set_validation');
}
